import jQuery from 'jquery';
import { accordions } from 'rp-gui-guide';

import { ajaxMarkup } from '../helpers/ajax';

export default class DynamicAccordions {
    constructor(customConfig) {
        const defaultConfig = {
            selectors: {
                accordion: '.js-RC-dynamicAccordion_cardPage',
                spinner: '.js-RC-cardSpinner'
            },
            classes: {
                active: 'RC-cardSpinner_active'
            },
            rows: [
                'raceVerdict',
                'diomedComments',
                'spotlightVerdict',
                'spotlightComments'
            ]
        };
        this.config = jQuery.extend(true, {}, defaultConfig, customConfig);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.bindEvents();
    }

    bindEvents() {
        jQuery(document).ready(this.load.bind(this));
    }

    load() {
        const url = this.buildUrl();

        if (!url) {
            return;
        }

        jQuery(this.config.selectors.spinner).addClass(this.config.classes.active);

        ajaxMarkup({
            type: 'GET',
            url
        })
            .done(this.handleSuccess)
            .always(this.handleFinish);
    }

    buildUrl() {
        return jQuery(this.config.selectors.accordion).data('cardRaceUrl');
    }

    handleSuccess(response) {
        jQuery(this.config.selectors.accordion).append(response);
        accordions();
        if (this.config.handleSuccess instanceof Function) {
            this.config.handleSuccess(this);
        }
        jQuery(document).trigger('dynamicPricesUpdated.PRICES');
    }

    handleFinish() {
        jQuery(this.config.selectors.spinner).removeClass(this.config.classes.active);
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/dynamicAccordions.js